import React, { useEffect, useRef } from 'react';

const AfsfhSeal: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Inline script to define global variables expected by AFSFH
    const setup = document.createElement('script');
    setup.type = 'text/javascript';
    setup.innerHTML = `
      afsfh_id = '5450af2dfa';
      afsfh_seal_width = 260;
      afsfh_seal_height = 178;
      afsfh_seal_format = 1;
    `;

    // External script that renders the seal
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.afsfh.com/seal/seal_server.js';

    // Append scripts in order
    containerRef.current.appendChild(setup);
    containerRef.current.appendChild(script);

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      role="img"
      aria-label="Association for Solution Focused Hypnotherapy Membership Seal"
      className="mt-4"
    />
  );
};

export default AfsfhSeal;


